export const createProductFullPath = (key = "") => {
    return process.env.REACT_APP_OSS_URL + "/static/" + key;
};
